import axios from 'axios'
import config from 'configs'

const http = axios.create({
  baseURL: config.json.base,
  // xsrfHeaderName: 'X-JIS-DEC-TOKEN',
  // withCredentials: true,
  crossDomain: true
})

const jsonGet = function (url, config, useCache = false) {
  if (!useCache) {
    var stampSign = /\?/.test(url) ? '&' : '?'
    url += stampSign + new Date().getTime()
  }
  return http.get(url, config)
}

export default {
  get: jsonGet,
  baseUrl: config.json.base
}



// WEBPACK FOOTER //
// ./src/json.js